import { isDebug } from './DebugFlags';

export type BuildTourDirection = 'to_island' | 'to_ship';

export interface BuildTourOptions {
  /** Mobile/touch profiles never get the QA buttons. */
  mobile: boolean;
  /** Invoked with the requested direction; the host sends `debug_build_tour`. */
  onJump: (direction: BuildTourDirection) => void;
}

/**
 * Debug-only QA buttons above the debug dock: jump the ship to a buildable
 * island spot and back. The buttons are created only when diagnostics are
 * enabled (and the profile is not touch), so a production page never gains
 * them; the authoritative destination is computed server-side from the
 * direction alone.
 */
export class BuildTour {
  constructor(options: BuildTourOptions) {
    if (typeof document === 'undefined' || !document.body) return;
    if (options.mobile || !isDebug()) return;

    const toIsland = document.createElement('button');
    toIsland.id = 'build-tour-to-island';
    toIsland.type = 'button';
    toIsland.textContent = 'Go to island';
    toIsland.title = 'Teleport the ship to a buildable island spot (debug)';
    toIsland.addEventListener('click', () => options.onJump('to_island'));

    const toShip = document.createElement('button');
    toShip.id = 'build-tour-to-ship';
    toShip.type = 'button';
    toShip.textContent = 'Back to ship';
    toShip.title = 'Return the ship to the pose saved before the jump (debug)';
    toShip.addEventListener('click', () => options.onJump('to_ship'));

    const root = document.createElement('div');
    root.id = 'build-tour-controls';
    root.append(toIsland, toShip);
    document.body.appendChild(root);
  }
}
